import {
  ICheckout, ICheckoutResponse
} from '@/entities'
import {
  IPaymentService
} from './index'
import {
  AxiosInstance,
  AxiosResponse
} from 'axios'
import {
  defaultConfig
} from '../config'


export class PaymentService implements IPaymentService {
  constructor(private readonly axios: AxiosInstance) {}

  async checkout(data: ICheckout): Promise<AxiosResponse<ICheckoutResponse>> {
    return this.axios.post('/create_checkout/', data, defaultConfig())
  }

}
